import type { Workspace } from '../types/workspace.types'

/**
 * Picks the workspace to activate, preferring lastUsedWorkspaceId when it is still valid.
 */
export function resolveWorkspaceFromList(
  workspaces: Workspace[],
  lastUsedWorkspaceId?: string | null
): Workspace | null {
  if (workspaces.length === 0) {
    return null
  }

  if (lastUsedWorkspaceId) {
    const lastUsed = workspaces.find((workspace) => workspace.id === lastUsedWorkspaceId)
    if (lastUsed) {
      return lastUsed
    }
  }

  return workspaces[0] ?? null
}
